import React from 'react';
import { IContract } from '../../../../../../../../model/shared/IContract';
import ContractHistoryDetail from './ContractHistoryDetail';

interface IContractHistoryTimelineProps {
    contracts: IContract[];
    isCharity: boolean;
}

/** The versions of a contract on a vertical timeline, the newest on top */
export function ContractHistoryTimeline({ contracts, isCharity }: IContractHistoryTimelineProps) {
    const newestFirst = [...contracts].sort(
        (a, b) => new Date(b.createdAt ?? 0).getTime() - new Date(a.createdAt ?? 0).getTime() || b.id - a.id
    );

    return (
        <div className="history-timeline">
            {newestFirst.map((contract, index) => (
                <ContractHistoryDetail
                    key={contract.id}
                    contract={contract}
                    previousContract={newestFirst[index + 1]}
                    isCharity={isCharity}
                />
            ))}
        </div>
    );
}
